import { StrictMode } from 'react'
// import { ThemeProvider } from 'next-themes'
import { createRoot } from 'react-dom/client'
import { Toaster } from '@/components/UI/Sonner'
import '@/store/theme'
import * as Sentry from '@sentry/react'

import './index.scss'
import 'virtual:uno.css'
import Router from './router'
import ErrorFallback from '@/components/ErrorFallback'
import { createElement } from 'react'

import 'prismjs';
// 导入 Prism CSS 主题
import 'prismjs/themes/prism.css';

// 导入你需要高亮的语言
import 'prismjs/components/prism-javascript';

// 初始化 Sentry (仅在生产环境)
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://5b142b3c0f452ebfe882fe0ebc9c0682@o1056860.ingest.us.sentry.io/4510459952103424",
    sendDefaultPii: true
  });
}

// 处理版本切换时的动态导入/chunk 加载失败，自动刷新一次避免卡死在白屏
const CHUNK_LOAD_MARKER_KEY = '__chunk_reload_marker__'
const CHUNK_LOAD_RETRY_COOLDOWN_MS = 60 * 1000
const CHUNK_LOAD_ERROR_PATTERNS = [
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
  'ChunkLoadError',
  'Loading chunk',
]

const getErrorMessage = (reason: unknown): string => {
  if (typeof reason === 'string') return reason
  if (reason instanceof Error) return `${reason.name}: ${reason.message}`

  if (reason && typeof reason === 'object') {
    const maybeMessage = (reason as { message?: unknown }).message
    if (typeof maybeMessage === 'string') return maybeMessage
  }

  return ''
}

const isChunkLoadError = (reason: unknown): boolean => {
  const message = getErrorMessage(reason)
  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => message.includes(pattern))
}

const shouldReloadForChunkError = (): boolean => {
  try {
    const raw = sessionStorage.getItem(CHUNK_LOAD_MARKER_KEY)
    if (!raw) return true

    const parsed = JSON.parse(raw) as { ts?: number } | null
    const ts = parsed?.ts
    if (typeof ts !== 'number') return true

    return Date.now() - ts > CHUNK_LOAD_RETRY_COOLDOWN_MS
  } catch {
    return true
  }
}

const markChunkReload = () => {
  try {
    sessionStorage.setItem(
      CHUNK_LOAD_MARKER_KEY,
      JSON.stringify({ ts: Date.now(), path: window.location.pathname }),
    )
  } catch {
    // 忽略 sessionStorage 异常，不影响主流程
  }
}

const handleChunkLoadFailure = (reason: unknown) => {
  if (!import.meta.env.PROD) return
  if (!isChunkLoadError(reason)) return

  if (!shouldReloadForChunkError()) {
    console.error('Chunk load failed after one retry, skip auto-reload.', reason)
    return
  }

  markChunkReload()
  console.warn('Detected chunk load failure, reloading page once.', reason)
  window.location.reload()
}

window.addEventListener('error', (event) => {
  const errorEvent = event as ErrorEvent
  handleChunkLoadFailure(errorEvent.error || errorEvent.message)
})

window.addEventListener('unhandledrejection', (event) => {
  handleChunkLoadFailure(event.reason)
})



createRoot(document.getElementById('root')!).render(
  <StrictMode>

    {/* <ThemeProvider attribute="class" defaultTheme="light"> */}
    <Sentry.ErrorBoundary fallback={createElement(ErrorFallback)}>
      <Router />
      <Toaster />
    </Sentry.ErrorBoundary>
    {/* </ThemeProvider> */}
  </StrictMode>
)
